<template>
  <div class="ut-container-lg ut-p-5">
    <div v-if="agentIsLoaded && userIsLoaded">
      <div>
        <vue-dropzone
          ref="myVueDropzone"
          :use-custom-slot="true"
          id="dropzone"
          :options="options"
          :destroyDropzone="true"
          :awss3="awss3"
          v-on:vdropzone-s3-upload-error="s3UploadError"
          v-on:vdropzone-success="dropzoneSuccess"
          v-on:vdropzone-sending="sending"
          v-on:vdropzone-removed-file="removeFile"
        >
          <div class="dz-message" data-dz-message>
            <div>Drop file here to upload</div>
            <div class="ut-text-xs">
              (Allowed types: image, pdf, word, excel)
            </div>
          </div>
        </vue-dropzone>
      </div>
      <info-card class="ut-mt-4" v-if="isSuccess" :info="success" />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import axios from "axios";
import InfoCard from "@/components/Cards/InfoCard.vue";
export default {
  name: "EvrFileUpload",
  components: {
    vueDropzone: vue2Dropzone,
    InfoCard,
  },
  props: {
    ak: Number,
    lid: Number,
    lk: String,
    callback: Function,
  },
  computed: {
    ...mapState({
      agent: (state) => state.agentStore.agent,
      user: (state) => state.userStore.user,
    }),
    agentIsLoaded() {
      return this.agent && this.agent.key;
    },
    userIsLoaded() {
      return this.user && this.user.key;
    },
    awss3() {
      return {
        signingURL: (f) => {
          return `${process.env.VUE_APP_API_URL}/FileStorageREST/s3-signed-url?filename=${f.name}&service=agent`;
        },
        headers: {},
        params: { userid: this.user.id, leadid: this.lid, subfolder: "EVR" },
        sendFileToServer: false,
        withCredentials: false,
      };
    },
  },
  data() {
    //    dictDefaultMessage: "Drop file here to upload",
    return {
      options: {
        method: "PUT",
        acceptedFiles: "image/*,.pdf,.doc,.xls,.docx,.xlsx",

        maxFilesize: 25,
        addRemoveLinks: false,
      },
      success: "File Uploaded Successfully",
      isSuccess: false,
      fileName: null,
    };
  },
  methods: {
    removeFile(file) {
      console.log(file);
    },
    dropzoneSuccess: function (file, res) {
      const parser = document.createElement("a");
      parser.href = file.s3Url;

      const url = parser.origin + parser.pathname;
      const uploadName = parser.pathname.split("agent/")[1];

      // upload the api here with the url

      const bodyFormData = new FormData();
      bodyFormData.append("agentkey", this.agent.key);
      bodyFormData.append("leadkey", this.lk);
      bodyFormData.append("uploadname", uploadName);
      bodyFormData.append("uploadtypeid", 5);
      bodyFormData.append("userkey", this.user.key);
      bodyFormData.append("filelocation", url);

      axios
        .post(
          `${process.env.VUE_APP_API_URL}/FileStorageREST/file-upload-data`,
          bodyFormData
        )
        .then((response) => {
          this.isSuccess = true;

          file.previewElement.parentNode.removeChild(file.previewElement);
          this.$refs.myVueDropzone.$el.className =
            this.$refs.myVueDropzone.$el.className.replace("dz-started", "");

          if (this.callback) {
            this.callback();
          }

          setTimeout(() => {
            this.isSuccess = false;
          }, 2500);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    s3UploadError(errorMessage) {
      // console.log(errorMessage);
    },
    sending(file) {
      this.fileName = file.name;
      if (!file.accepted) {
        // abort doesn't work. Setting the timeout is the only thing I've found that cancels the s3 request.
        file.xhr.timeout = 1;
      }
    },
  },
};
</script>
<style scoped lang="scss">
</style>